export default {
	"breadcrumbs.home": "Startseite",
} as const;
